import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "@/data/site";

const Sep = ({ dark }) => (
  <span
    className={`inline-block w-2 h-2 rotate-45 mx-8 sm:mx-12 shrink-0 ${
      dark ? "bg-gold/70" : "bg-ink/70"
    }`}
  />
);

export default function EditorialMarquee({ variant = "gold", testId = "editorial-marquee" }) {
  const gold = variant === "gold";
  return (
    <div
      data-testid={testId}
      className={`relative overflow-hidden py-5 sm:py-6 border-y ${
        gold ? "bg-gold border-gold-dark/40" : "bg-ink border-white/10"
      }`}
    >
      <Marquee speed={38} gradient={false} pauseOnHover>
        {MARQUEE_ITEMS.concat(MARQUEE_ITEMS).map((item, i) => (
          <span key={i} className="inline-flex items-center">
            <span
              className={`font-display uppercase tracking-[0.22em] text-sm sm:text-base whitespace-nowrap ${
                gold ? "text-ink font-semibold" : "text-outline-gold"
              }`}
            >
              {item}
            </span>
            <Sep dark={!gold} />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
